import { ReplaySubject } from 'rxjs';
var subjectsAndObservables = new WeakMap();
var getComponentSubjectsAndObservables = function (instance) {
    var componentSubjectsAndObservables = subjectsAndObservables.get(instance);
    if (componentSubjectsAndObservables) {
        return componentSubjectsAndObservables;
    }
    var newComponentSubjectsAndObservables = new Map();
    subjectsAndObservables.set(instance, newComponentSubjectsAndObservables);
    return newComponentSubjectsAndObservables;
};
var getSubjectAndObservable = function (instance, propertyKey) {
    var componentSubjectsAndObservables = getComponentSubjectsAndObservables(instance);
    var subjectAndObservable = componentSubjectsAndObservables.get(propertyKey);
    if (subjectAndObservable) {
        return subjectAndObservable;
    }
    var subject = new ReplaySubject(1);
    var newSubjectAndObservable = { observable: subject.asObservable(), subject: subject };
    componentSubjectsAndObservables.set(propertyKey, newSubjectAndObservable);
    return newSubjectAndObservable;
};
export function ObservableInput() {
    return function (target, propertyKey) {
        delete target[propertyKey];
        Object.defineProperty(target, propertyKey, {
            set: function (value) {
                getSubjectAndObservable(this, propertyKey).subject.next(value);
            },
            get: function () {
                return getSubjectAndObservable(this, propertyKey).observable;
            },
        });
    };
}
